import { Component, OnInit, Input, Inject, ElementRef, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Product } from '../../../order/models/product';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-product-info-popup',
  templateUrl: 'product-info-popup.component.html',
  styleUrls: ['product-info-popup.component.scss']
})

export class ProductInfoPopupComponent implements OnInit {

  product: Product;

  constructor(
    public dialogRef: MatDialogRef<ProductInfoPopupComponent>,
    private ref: ElementRef,
    private renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private shopSettingsService: ShopSettingsService,
  ) {
    this.product = data.product;
  }

  ngOnInit(): void {
    if (this.shopSettingsService.isVUMode) {
      this.renderer.addClass(this.ref.nativeElement, 'vu-mode');
    }
  }

  closeClick(): void {
    this.dialogRef.close();
  }

  buildUrl(productId: number): string {
    if (this.shopSettingsService.shopSettings.isShowProductImages) {
      return `/store/product_image/${productId}` + '?type=image_medium';
    }
    return null;
  }

  toMoneyStr(x: number): string {
    if (typeof x !== 'number') {
      return '';
    }
    return environment.globalSettings.toMoneyStr(x);
  }
}
